import * as React from "react";
import * as cookie from "js-cookie";

// helpers
import { useEventCallback } from "@vingle/wtf-sdk/helpers/hook";

// components
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import PACKS from "common/icons/packs";
import { IconWrapper } from "common/icons";

const styles = require("./helloBar.scss");

const HELLO_BAR_COOKIE_NAME = "hello_bar_cookie";

interface IProps {
  link: string;
}

export default function HelloBar({ link }: IProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const onCloseButtonClick = useEventCallback(() => {
    setIsOpen(false);
    cookie.set(HELLO_BAR_COOKIE_NAME, "1");
  }, []);

  React.useEffect(() => {
    if (!isOpen && !cookie.get(HELLO_BAR_COOKIE_NAME)) {
      setIsOpen(true);
    }
  }, []);

  return isOpen ? (
    <div className={styles.wrapper}>
      <div className={styles.banner}>
        <div className={styles.background}>
          <IconWrapper
            icon={PACKS.TRENDING_DISCOVER.HELLO_BANNER_BACKGROUND}
            className={styles.img}
          />
        </div>
        <div className={styles.contents}>
          <FormattedMessage
            id="discover.hello_bar.contents"
            values={{
              span: (msg: string) => (
                <span className={styles.pinkText}>{msg}&nbsp;</span>
              ),
            }}
          />
          <Link to={link} className={styles.exploreMoreButton}>
            <FormattedMessage id="discover.hello_bar.explore_more" />
          </Link>
        </div>
        <IconWrapper
          icon={PACKS.TRENDING_DISCOVER.HELLO_BANNER_CLOSE_BUTTON}
          className={styles.closeButton}
          onClick={onCloseButtonClick}
        />
      </div>
    </div>
  ) : null;
}
